import { TWTransactionTableItem } from "./types";
import { WSButton, WSFlexBox, WSText } from "@wingspanhq/fe-component-library";
import React from "react";
import { useModalCancelPendingWithholding } from "../../modals/ModalCancelPendingWithholding";
import { WithholdingTransactionType } from "@wingspanhq/bookkeeping/dist/lib/interfaces";

export const NameCell: React.FC<{
  data: TWTransactionTableItem;
}> = ({ data }) => {
  const modalCancelPendingWithholding = useModalCancelPendingWithholding();

  let action: React.ReactNode = null;

  // Only show cancel option for IRS scheduled transactions not withdrawals and deposits
  if (data.type === WithholdingTransactionType.TaxPayment && data.isPending) {
    action = (
      <WSButton.Link
        size="S"
        onClick={() => {
          modalCancelPendingWithholding.open({
            pendingWithholdingId: data.transactionId,
            amount: data.amount,
            currency: data.currency,
            date: data.date
          });
        }}
        destructive
      >
        Cancel
      </WSButton.Link>
    );
  }

  return (
    <WSFlexBox.CenterY gap="XS" wrap="nowrap" justify="space-between" fullWidth>
      <WSText.ParagraphSm>{data.title}</WSText.ParagraphSm>
      {action}
    </WSFlexBox.CenterY>
  );
};
